export const AUTO_MODE_VALUE = 'auto'
export const OFF_MODE_VALUE = 'off'
